import script from "./PageNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageNav.vue?vue&type=script&setup=true&lang=ts"

import "./PageNav.vue?vue&type=style&index=0&id=5aa8eb14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa8eb14"]])

export default __exports__